import { render, staticRenderFns } from "./publicationsForm.vue?vue&type=template&id=2827fb87"
import script from "./publicationsForm.vue?vue&type=script&lang=js"
export * from "./publicationsForm.vue?vue&type=script&lang=js"
import style0 from "./publicationsForm.vue?vue&type=style&index=0&id=2827fb87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports